export default {
	'--color1v1': '#f57e0b',
	'--color1v2': '#d95a06',
	'--color1v1Border': '#d95a06',
	'--color1v2Border': '#b43b09',
	'--color1Text': 'white',

	'--color2v1': '#4792ea',
	'--color2v2': '#387adf',
	'--color2v1Border': '#387adf',
	'--color2v2Border': '#2961cc',
	'--color2Text': 'white',

	'--inputColor': '#fdd68a',
	'--inputText': 'black',

	'--disabledButton': '#ced1d3',
	'--disabledButtonBorder': '#a9aeb1',
	'--disabledButtonText': 'black',

	'--footerbg': 'black',
	'--footerText': 'white',

	'--headerColor': '#f2f5fc',
	'--headerText': 'black',
	'--navButtonBorder': 'black',

	'--backgroundColor': '#f0f7fe',
	'--backgroundColorText': 'black'
} as React.CSSProperties;
